import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {addEditPharmacy, delPharmacy, generatePharmacyUser, getPharmacies} from '../../services';
import {IPharmacy, IPharmacyFilter, IPharmacyRes, IPharmacyState} from "../types/IPharmacy";
import historyHelper from "../../helpers/history";
import {AppState} from "./rootReducer";

const initialState: IPharmacyState = {
    status: "idle"
}

export const mostrarPharmacies = createAsyncThunk(
    'mostrarPharmacies', async (params:IPharmacyFilter|undefined, thunkAPI ) => {
        const {pharmacies} = thunkAPI.getState() as AppState;
        let paramsFilter = params || pharmacies.filtered;

        const response = await getPharmacies(paramsFilter)
        return {data: response.data as IPharmacyRes, params: response.config.params}
    }
)

export const agregarEditarPharmacy = createAsyncThunk(
    'Pharmacies/agregarEditar', async (pharmacy: IPharmacy, thunkAPI) => {
        const response = await addEditPharmacy(pharmacy);
        if (response.status === 200 || response.status === 204) {
            historyHelper.back()
        };
        return {data: response.data, edit:!!pharmacy.id};
    }
);
export const mostrarPharmacyById = createAsyncThunk(
    'mostrarPharmacyById', async (id:number,thunkAPI) => {
        // let byId = (thunkAPI.getState() as AppState)?.pharmacies?.list?.items?.find(c=>c.id === id);
        // if(byId){
        //     return {data: byId}
        // }

        const response = await getPharmacies(id);
        return {data: response.data as IPharmacy}
    }
)

export const eliminarPharmacy = createAsyncThunk(
    'pharmacy/eliminar', async (id: number) => {
        await delPharmacy(id);
        // if (response.status === 200 || response.status === 204) historyHelper.back();
        return id;
    }
);

export const generarUsuarioPharmacy = createAsyncThunk(
    'farmacia/generarUsuario', async (id: number) => {
        const response = await generatePharmacyUser(id);
        // if (response.status === 200 || response.status === 204) {
        //     historyHelper.push(historyHelper.location.pathname,response.data);
        // }

        return {data: response.data};
    }
);


const slice = createSlice({
    name: 'mostrarPharmacies',
    initialState,
    reducers: {
    },
    extraReducers: builder => {
        //--mostrarPharmacies
        builder.addCase(mostrarPharmacies.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(mostrarPharmacies.fulfilled, (state,action ) => {
            state.status = "idle";
            state.filtered = action.payload.params;
            state.list = action.payload.data;
        })
        builder.addCase(mostrarPharmacies.rejected, (state ) => {
            state.status = "idle";
        })

        //--agregarEditarPharmacy
        builder.addCase(agregarEditarPharmacy.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(agregarEditarPharmacy.fulfilled, (state,action ) => {
            state.status = "idle";
            if(state.list){
                state.list.items = state.list?.items.filter(e => e.id !== action.payload.data.id);
                state.list.items.unshift(action.payload.data);
                if(!action.payload.edit){
                    ++state.list.pageSize
                    ++state.list.totalCount
                }

            }
        })
        builder.addCase(agregarEditarPharmacy.rejected, (state ) => {
            state.status = "idle";
        })
        //--mostrarPharmacyById
        builder.addCase(mostrarPharmacyById.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(mostrarPharmacyById.fulfilled, (state,action ) => {
            state.status = "idle";
            state.byId = action.payload.data;
        })
        builder.addCase(mostrarPharmacyById.rejected, (state ) => {
            state.status = "idle";
        })

        //--eliminarPharmacy
        builder.addCase(eliminarPharmacy.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(eliminarPharmacy.fulfilled, (state,action ) => {
            state.status = "idle";
            const id = action.payload;
            if(state.list?.items){
                state.list.items = state.list?.items.filter(e => e.id !== id)
            }
        })
        builder.addCase(eliminarPharmacy.rejected, (state ) => {
            state.status = "idle";
        })
        //--generar Usuario
        builder.addCase(generarUsuarioPharmacy.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(generarUsuarioPharmacy.fulfilled, (state,action ) => {
            state.status = "idle";
            state.byId = {...state.byId, userId:action.payload.data.id}
        })
        builder.addCase(generarUsuarioPharmacy.rejected, (state ) => {
            state.status = "idle";
        })
    }
});

export default slice.reducer;
